import styled from "@emotion/styled";
import { media } from "../../components/Window/themes";
const ChannelMember = {
    Wrapper: styled.div `
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
    Header: styled.div `
    font-weight: bold;
    color: ${({ theme }) => theme.color.headerTextColor};
    padding: 1.3rem;
    margin-bottom: 0.5rem;
    border-bottom: 0.1rem solid rgba(6, 6, 7, 0.08);
    ${media.medium} {
      padding: 1rem 5rem 1rem;
    }
  `,
    Text: styled.p `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80%;
  `,
    Container: styled.div `
    display: flex;
    flex-direction: column;
    min-height: 0;
    margin-right: 1rem;
    ${media.medium} {
      margin-right: 0;
    }
  `,
    UserContainer: styled.div `
    padding: 0.4em;
    flex-basis: 100%;
    overflow: hidden;
    box-shadow: inset -2px -2px 13px -6px #c9c9c9;
  `,
    UserList: styled.ul `
    list-style-type: none;
    margin-top: 0.5em;
    height: 80%;
    overflow-y: auto;
    padding-inline-start: unset;
  `,
    MembersList: styled.ul `
    padding: 0.4em;
    overflow: auto;
    flex-basis: 100%;
    margin-bottom: 1em;
    box-shadow: -2px -2px 13px -6px #c9c9c9;
  `,
    ListItem: styled.li `
    padding: 0.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
  `,
    LeaveButton: styled.button `
    color: #de4e46;
    cursor: pointer;
    background-color: transparent;
    background-image: none;
    border-color: #de4e46;
    display: inline-block;
    font-weight: 200;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid;
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-bottom: 1rem;
    margin-right: 1rem;
    &:hover {
      color: #fff;
      background-color: #de4e46;
      border-color: #de4e46;
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
      margin-left: 1rem;
    }
  `,
    RemoveButton: styled.button `
    cursor: pointer;
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-inline-start: 0.5em;
    &:hover {
      color: #fff;
      background-color: #c82333;
      border-color: #bd2130;
    }
    &:focus {
      box-shadow: 0 0 0 0.2rem rgb(220 53 69 / 50%);
    }
    ${media.medium} {
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
  `,
    Button: styled.button `
    color: ${({ theme }) => theme.color.backgroundBrand};
    cursor: pointer;
    background-color: transparent;
    background-image: none;
    border-color: ${({ theme }) => theme.color.backgroundBrand};
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:hover {
      color: ${({ theme }) => theme.color.background};
      background-color: ${({ theme }) => theme.color.backgroundBrand};
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
  `,
    ButtonWrapperMembers: styled.div `
    ${media.medium} {
      display: flex;
      flex-direction: row;
    }
  `,
    AddButton: styled.button `
    color: ${({ theme }) => theme.color.backgroundBrand};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    background-color: transparent;
    background-image: none;
    border-color: ${({ theme }) => theme.color.backgroundBrand};
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:hover {
      color: ${(props) => props.disabled
        ? ({ theme }) => theme.color.backgroundBrand
        : ({ theme }) => theme.color.background};
      background-color: ${(props) => props.disabled
        ? "transparent"
        : ({ theme }) => theme.color.backgroundBrand};
      border-color: ${({ theme }) => theme.color.backgroundBrand};
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
  `,
    ButtonWrapper: styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    ${media.medium} {
      gap: 5px;
    }
  `,
    ChannelSearchContainer: styled.div `
    flex-basis: 100%;
    background-color: ${({ theme }) => theme.color.background};
  `,
    ChannelSearchInputWrapper: styled.div `
    display: flex;
    flex-basis: 100%;
    align-items: center;
    height: 40px;
    background: ${({ theme }) => theme.color.background};
    border-radius: 0.25rem;
    border: 1px solid lightgrey;
    ${media.medium} {
      margin-left: 0;
      height: 23px;
    }
  `,
    ChannelSearchInputIcon: styled.div `
    flex-basis: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    justify-content: start;
    padding-left: 10px;
  `,
    ChannelSearchInputText: styled.input `
    background: none;
    border: none;
    font-size: 16px;
    outline: none;
    flex-basis: 100%;
    color: ${({ theme }) => theme.color.textMuted};
    ::placeholder {
      color: ${({ theme }) => theme.color.textMuted};
    }
    ${media.medium} {
      font-size: 0.8rem;
    }
  `,
    Title: styled.p `
    font-weight: bold;
    margin-top: 0.5em;
  `,
};
export default ChannelMember;
//# sourceMappingURL=ChannelMember.styled.js.map